import * as z from 'zod';

import { phoneNumberQuerySchema } from '@/_schemas/phone-numbers';

import { emergencyContactQuerySchema } from './emergency-contact-query-schema';

export const emergencyContactFormSchema = emergencyContactQuerySchema
  .omit({
    email: true,
    phone_numbers: true,
    relationship: true,
  })
  .extend({
    email: z.string(),
    phone_numbers: z.array(phoneNumberQuerySchema),
    relationship: z.string(),
  });

export type EmergencyContactFormSchema = z.infer<typeof emergencyContactFormSchema>;
